import React from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import { CardGiftcardOutlined as GiftCardIcon } from "@mui/icons-material";
import { Path } from "../../../../../static/Constants";
import NoData from "../../../../Components/ui/feedback/NoData";

const GiftCardDetailEmptyState = ({ cardId, onRetry }) => {
  const history = useHistory();

  return (
    <NoData
      icon={<GiftCardIcon sx={{ fontSize: 32 }} />}
      title="Gift Card Not Found"
      description={
        cardId !== undefined && cardId !== null && cardId !== ""
          ? `We couldn't retrieve Gift Card #${cardId}. The card may not exist on this network or the RPC request timed out.`
          : "The requested gift card was not found or has been removed."
      }
      actionText="Browse All Gift Cards"
      onAction={() => history.push(Path.allgiftcards)}
      paper
      minHeight={360}
      maxWidth={480}
    />
  );
};

GiftCardDetailEmptyState.propTypes = {
  cardId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onRetry: PropTypes.func,
};

export default GiftCardDetailEmptyState;
